import { X } from "@phosphor-icons/react";
import { cn } from "@/lib/cn";
import { Button } from "@/components/primitives/Button";
import type { TableBulkActionsProps } from "./DataTable.types";

export function TableBulkActions({ selectedCount, actions, onClearSelection, label, className }: TableBulkActionsProps) {
  if (selectedCount <= 0) return null;

  return (
    <div className={cn("bfrs-flex bfrs-flex-wrap bfrs-items-center bfrs-gap-2 bfrs-border-b bfrs-border-border bfrs-bg-primary-soft bfrs-px-5 bfrs-py-2", className)}>
      <span className="bfrs-text-sm bfrs-font-semibold bfrs-text-success-contrast">{label ?? `${selectedCount} selected`}</span>
      {actions}
      <div className="bfrs-min-w-2 bfrs-flex-1" />
      {onClearSelection && (
        <Button variant="secondary" size="sm" leftIcon={<X size={13} />} onClick={onClearSelection}>
          Clear selection
        </Button>
      )}
    </div>
  );
}
